/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Strength_PartialInputs */

const en_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const de_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const fr_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const es_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const it_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const nl_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const pl_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const fi_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const da_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

const sv_story_bank_strength_partial = /** @type {(inputs: Story_Bank_Strength_PartialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partial`)
};

/**
* | output |
* | --- |
* | "Partial" |
*
* @param {Story_Bank_Strength_PartialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_strength_partial = /** @type {((inputs?: Story_Bank_Strength_PartialInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Strength_PartialInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_strength_partial(inputs)
	if (locale === "fr") return fr_story_bank_strength_partial(inputs)
	if (locale === "es") return es_story_bank_strength_partial(inputs)
	if (locale === "it") return it_story_bank_strength_partial(inputs)
	if (locale === "nl") return nl_story_bank_strength_partial(inputs)
	if (locale === "pl") return pl_story_bank_strength_partial(inputs)
	if (locale === "fi") return fi_story_bank_strength_partial(inputs)
	if (locale === "da") return da_story_bank_strength_partial(inputs)
	if (locale === "sv") return sv_story_bank_strength_partial(inputs)
	return en_story_bank_strength_partial(inputs)
});